import { render, staticRenderFns } from "./userTerminal.vue?vue&type=template&id=32eabf72&scoped=true&"
import script from "./userTerminal.vue?vue&type=script&lang=js&"
export * from "./userTerminal.vue?vue&type=script&lang=js&"
import style0 from "./userTerminal.vue?vue&type=style&index=0&id=32eabf72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eabf72",
  null
  
)

export default component.exports